import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-bank',
  templateUrl: './bank.component.html',
  styleUrls: ['./bank.component.scss'],
})
export class BankComponent implements OnInit {
  color: string = '#162A62';
  @Input() status: string;
  constructor() { }

  ngOnInit() {
    if (this.status == 'cbu') {
      this.color = '#3B6CF8';
    } else {
      this.color = '#162A62';
    }
  }

}
